import ReplyIcon from '@mui/icons-material/Reply'
import axios from 'axios'
import dayjs from 'dayjs'
import { useContext, useRef, useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import pencilIcon from 'src/assets/pencil.png'
import uploadCloudIcon from 'src/assets/upload_cloud.png'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { apiURL, commonHeadersWeb } from 'src/consumer/services'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'
import { getData, postData } from 'src/consumer/services/profileService'
import { isValidHttpUrl } from 'src/mentor/helpers/utilityFunctions'
import { APP_CONSTANTS } from '../../constants'
import { getFlagEmoji, profileOptionsList } from '../../helpers/profilePageHelper'
import {
  BackHomeText,
  CameraIcon,
  IndeterminateLoading,
  MembershipStatusBox,
  MembershipText,
  ProfileId,
  ProfileIntitial,
  ProfileLeftPannelContainer,
  ProfileMembership,
  ProfileName,
  ProfileOption,
  ProfileOptionIcon,
  ProfileOptionsList,
  ProfilePicture,
  ProfileUpgradeButton,
  ProfileInfoCard,
  ProfileCardHeader,
  ProfileCardContent,
  ProfileCardNameRow,
} from './ProfileLeftPannelStyle'

const renderOptionsList = (props, handleLogOut) => {
  const { selectedProfileOption, setProfileOption, localizedContent } = props
  return profileOptionsList?.map((option) => {
    const IconComponent = option?.icon
    return (
      <ProfileOption
        onClick={() => {
          if (option?.id === 'logout') {
            handleLogOut()
          }
          setProfileOption(option?.id)
        }}
        isSelected={selectedProfileOption === option?.id}
        key={option?.id}
        optionId={option?.id}
      >
        {option?.isMuiIcon ? (
          <IconComponent sx={{ width: 20, height: 20, marginRight: '10px' }} />
        ) : (
          <ProfileOptionIcon src={option?.icon} />
        )}
        {localizedContent?.[option?.id] || option?.displayName}
      </ProfileOption>
    )
  })
}

const ProfileLeftPannel = (props) => {
  const { profileData, setProfileData } = useContext(ProfileContext)
  const [openLogoutConfirm, setOpenLogoutConfirm] = useState(false)
  const { name, email, subscriptionType, profilePicId, location, subscriptionEndDate } = profileData
  const navigate = useNavigate()
  const fileInputRef = useRef(null)
  const [tempImgUrl, setTempImgUrl] = useState()
  const [waitingPictureUpload, setWaitingPictureUpload] = useState(false)

  const isFreeUser = profileData?.subscriptionTypeId === 'subscription_free'

  const { openPrewallFunction } = useOutletContext()

  const handleLogOut = () => {
    logoutHandler()
    navigate('/login')
  }

  const handleClick = () => {
    fileInputRef?.current?.click()
  }

  const handleFileUpload = async (event) => {
    const file = event?.target?.files[0] //getting the file

    const reader = new FileReader()
    reader.onload = () => {
      setTempImgUrl(reader.result)
    }
    reader.readAsDataURL(file) //for showing image without waiting for api response

    const formData = new FormData()
    formData?.append('file', file)

    setWaitingPictureUpload(true)

    try {
      const response = await axios.post(`${apiURL}/api/media/file/upload`, formData, {
        headers: {
          ...commonHeadersWeb,
          'ef-user-country-code': localStorage.getItem('countryCode'),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      })

      if (response?.status === 200) {
        let profileUpdatePayload = profileData
        profileUpdatePayload['profilePicId'] = response?.data?.fileId

        const updateResponse = await postData('/api/secure/user/update', profileUpdatePayload)

        if (updateResponse?.status === 200) {
          setWaitingPictureUpload(false)
          const resp = await getData('/api/secure/user/profile')
          if (resp?.status === 200) {
            setProfileData(resp?.data)
          }
        } else {
          setTempImgUrl(null)
          setWaitingPictureUpload(false)
        }
      } else {
        setTempImgUrl(null)
        setWaitingPictureUpload(false)
      }
    } catch (error) {
      console.log(error)
      setTempImgUrl(null)
      setWaitingPictureUpload(false)
    }
    // uploading image, updating profile and updating profile data
  }

  return (
    <ProfileLeftPannelContainer>
      <BackHomeText onClick={() => navigate('/')}>
        <ReplyIcon sx={{ fontSize: 14, color: 'white' }} />
        <div>Back to Homepage</div>
      </BackHomeText>

      <ProfileInfoCard>
        <ProfileCardHeader>
          {profilePicId || tempImgUrl ? (
            <ProfilePicture
              imgURL={
                tempImgUrl ||
                (isValidHttpUrl(profilePicId) ? profilePicId : APP_CONSTANTS.MEDIA_URL + profilePicId)
              }
            >
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
              <CameraIcon src={uploadCloudIcon} onClick={handleClick} />
              {waitingPictureUpload && <IndeterminateLoading />}
            </ProfilePicture>
          ) : (
            <ProfileIntitial>
              {name[0] || ''}
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
              <CameraIcon src={pencilIcon} onClick={handleClick} />
            </ProfileIntitial>
          )}
          
          <ProfileCardContent>
            <ProfileCardNameRow>
              <ProfileName>{name}</ProfileName>
            </ProfileCardNameRow>
            <ProfileId>{email}</ProfileId>
            <ProfileId>
              {location?.country}&nbsp;
              {getFlagEmoji(location?.countryCode || '')}
            </ProfileId>
          </ProfileCardContent>
        </ProfileCardHeader>

        <MembershipStatusBox>
          <MembershipText>
            <div>Membership</div>
            <ProfileMembership>{subscriptionType?.name}</ProfileMembership>
            {subscriptionType?.id === 'subscription_normal' && (
              <div>Valid till {dayjs.unix(subscriptionEndDate).format('MMM D, YYYY')}</div>
            )}
          </MembershipText>

          {isFreeUser && (
            <ProfileUpgradeButton onClick={() => openPrewallFunction('upgrade_btn')}>
              Upgrade
            </ProfileUpgradeButton>
          )}
        </MembershipStatusBox>
      </ProfileInfoCard>

      <ProfileOptionsList>{renderOptionsList(props, handleLogOut)}</ProfileOptionsList>
    </ProfileLeftPannelContainer>
  )
}

export default ProfileLeftPannel
